import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ApprovalIcon(props: IconProps) {
    return <Icon {...props} iconKey={"approval"}/>
}
